export default __webpack_public_path__ + "static/media/pink-gradient.43507ec2.png";